import { render, staticRenderFns } from "./siderRightHistory.vue?vue&type=template&id=36c76af7&scoped=true&"
import script from "./siderRightHistory.vue?vue&type=script&lang=js&"
export * from "./siderRightHistory.vue?vue&type=script&lang=js&"
import style0 from "./siderRightHistory.vue?vue&type=style&index=0&id=36c76af7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c76af7",
  null
  
)

export default component.exports